import * as XLSX from 'xlsx';

export const exportRowsToExcel = (rows, columns, fileName, sheetName = 'Sheet1') => {
  const header = columns.map(col => col.header);
  const data = rows.map(row =>
    columns.map(col => {
      const value = col.accessor(row);
      return value == null ? '' : String(value);
    })
  );

  const worksheet = XLSX.utils.aoa_to_sheet([header, ...data]);
  worksheet['!cols'] = columns.map(col => ({ wch: col.width || 18 }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, fileName);
};
